module.exports = __webpack_public_path__ + "static/assets/78e671b246af4d809e7b240bc1ca93b8.svg";